import { useTranslation } from "react-i18next";
import useLodStore from "store/lod";
import { useGetData } from "./service";
import { dateFormat, priceFormat } from "components/utils/comm";
import Resvs from "./resvs";

export default function Base() {
  const { t } = useTranslation();
  const lod = useLodStore((state) => state.lod);
  const lodNo = lod?.lodNo;

  const { dayChkInList, dayPayInf } = useGetData();

  return (
    <>
      {!lodNo && (
        <h2 className="text-center text-red-300 pt-10" hidden={!!lodNo}>
          예약현황을 확인하시려면 <br /> 먼저 헤더에서 숙소를 선택하여 주세요.
        </h2>
      )}
      {!!lodNo && (
        <>
          {/* 오늘 예약현황 */}
          <div className="flex justify-start gap-5 py-5">
            <div className="card w-1/4">
              <h3 className="text-sm">[오늘 예약현황]</h3>
              {/* 숙소번호, 예약날짜, 예약건수, 취소건수, 결제금액, 취소금액, 정산금액 */}
              <ul className="pt-2">
                <li>
                  <h4>{t("grid_lod_no")}</h4>
                  <h4 className="">{lod?.lodNo}</h4>
                </li>
                <li>
                  <h4>{t("grid_resv_dt")}</h4>
                  <h4>{dateFormat(dayPayInf?.resvDt ?? "-", "-")}</h4>
                </li>
                <li>
                  <h4 className="">{t("grid_resv_ct")}</h4>
                  <h4>{dayPayInf?.resvCt}</h4>
                </li>
                <li>
                  <h4>{t("grid_resv_cnl_ct")}</h4>
                  <h4>0</h4>
                </li>
                <li>
                  <h4>{t("grid_resv_pay_amt")}</h4>
                  <h4>{priceFormat({ price: dayPayInf?.resvPayAmt ?? 0 })}</h4>
                </li>
                <li>
                  <h4>{t("grid_resv_cnl_amt")}</h4>
                  <h4>{priceFormat({ price: dayPayInf?.resvCnlAmt ?? 0 })}</h4>
                </li>
                <li>
                  <h4>{t("grid_resv_cal_amt")}</h4>
                  <h4>{priceFormat({ price: dayPayInf?.resvCalAmt ?? 0 })}</h4>
                </li>
              </ul>
            </div>
          </div>

          {/* 오늘 예약고객 */}
          <Resvs defaultInList={dayChkInList} />
        </>
      )}
    </>
  );
}
// 숙소선택
// <div className="py-4">
//   <div className="home _card">
//     <h4 className="flex items-center gap-2">
//       <span>{(use?.manFstNm ?? "") + " " + (use?.manSurNm ?? "")}</span>
//       <p className="pt-1 text-red-400 text-[9px] leading-3">
//         ({t("txt_1_home")})
//       </p>
//     </h4>

//     <ul className="flex col gap-3 p-3 ">
//       <li className="flex gap-3">
//         <label htmlFor="">{t("lbl_lod_grp_cmm")}</label>
//         <input
//           type="text"
//           name="lodGrpNo"
//           value={lodGrpList[0]?.lodGrpNm ?? "--"}
//           className="flex-1"
//           readOnly
//         />
//       </li>
//       <li className="flex gap-3">
//         <label htmlFor="">{t("lbl_lod_cmm")}</label>
//         <LodNmSelct lodList={lodList} />
//       </li>
//     </ul>
//   </div>
// </div>
